<template>
  <div class="payment">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">Select expert level</h4>
        <div class="text-left">
          <label for="opt1" class="radio text-left">
            <input
              type="radio"
              name="rdo"
              id="opt1"
              class="hidden"
              value="1"
              v-model="complexity"
            />
            <span class="label"></span> Junior ($5 - $20/hr)
          </label>
          <br />

          <label for="opt2" class="radio text-left">
            <input
              type="radio"
              name="rdo"
              id="opt2"
              class="hidden"
              value="2"
              v-model="complexity"
            />
            <span class="label"></span> Intermediate ($10 - $40/hr)
          </label>
          <br />

          <label for="opt3" class="radio text-left">
            <input
              type="radio"
              name="rdo"
              id="opt3"
              class="hidden"
              value="3"
              v-model="complexity"
            />
            <span class="label"></span> Senior ($15- $80/hr)
          </label>
          <br />
          <br />
          <h6 class="mb-3 font-weight-bold text-left">
            Number of Talent(s) to hire
          </h6>

          <a-input-number
            :precision="number"
            size="large"
            placeholder="1,2,3"
            v-model="talent_size"
            class="mx-auto mb-3 w-100"
          />

          <!-- <div class="ml-5" v-if="showInput">
                    State it:  <input type="number" class="input" placeholder="1000"/>
          </div>-->
        </div>
        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >
                Back
              </button>
            </div>
            <div class="col text-right">
              <button
                class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="next"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "job-expert-level",
  data() {
    return {
      complexity: this.$store.state.fcjob.fcjobData.complexity,
      talent_size: this.$store.state.fcjob.fcjobData.talent_size
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { complexity, talent_size } = this;
      this.$store.commit("fcjob/updateFcJob", {
        complexity,
        talent_size
      });
      this.$router.push("job-salary");
    },
    skip() {
      this.$router.push("job-salary");
    }
  }
};
</script>
<style scoped>
.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
